import type { Referential, ReferentialFilters } from '../types'

export function filterReferentials(
  referentials: Referential[],
  filters: ReferentialFilters
): Referential[] {
  const search = filters.search.trim().toLowerCase()

  return referentials.filter((referential) => {
    if (filters.agencyId && referential.groupId !== filters.agencyId) {
      return false
    }

    if (search) {
      const haystack = [referential.name, referential.description ?? '']
        .join(' ')
        .toLowerCase()

      if (!haystack.includes(search)) {
        return false
      }
    }

    if (filters.clientFilter === 'independent' && referential.clientOrganizationId) {
      return false
    }

    if (
      filters.clientFilter !== 'all' &&
      filters.clientFilter !== 'independent' &&
      referential.clientOrganizationId !== filters.clientFilter
    ) {
      return false
    }

    if (filters.statusFilter === 'active' && !referential.active) {
      return false
    }

    if (filters.statusFilter === 'inactive' && referential.active) {
      return false
    }

    return true
  })
}
